// extracted by mini-css-extract-plugin
module.exports = {"root":"root___3h9Bs","loading":"loading___2Nvg3"};